import { Route } from '@angular/router';

import { TaskListTemplatesTaskListTemplateResolver } from '../task-list-templates.resolvers';
import { TaskListTemplatesDetailsComponent } from './details.component';
import { TaskFieldDefsResolver, TaskTabListsResolver } from 'app/shared/modules/legacy-tasks/tasks.resolvers';
import { ProjectDataResolver } from 'app/modules/projects/projects.resolvers';
import { CanActivateTaskListTemplatesDetails, CanDeactivateTaskListTemplatesDetails } from './details.guard';
import { TaskListTemplateTaskResolver } from '../../settings.resolvers';
import { TaskDetailsComponent } from '@tasks/task-details/task-details.component';

export const taskListTemplatesDetailsRoutes: Route[] = [
  {
    path: '',
    component: TaskListTemplatesDetailsComponent,
    resolve: {
      taskListTemplate: TaskListTemplatesTaskListTemplateResolver,
      taskFieldDefs: TaskFieldDefsResolver,
      taskTabLists: TaskTabListsResolver,
      options: ProjectDataResolver,
    },
    children: [
      {
        path: 'newtasks',
        loadChildren: () => import('@tasks/tasks.routes').then((m) => m.routes),
      },
    ],
  },
];
